// extracted by mini-css-extract-plugin
export default {"verifyingAccount":"LoginPage_verifyingAccount__7tUWK","recoveryText":"LoginPage_recoveryText__7CHKa"};